import { ITicket } from "./ITicket"
import { SellingSession } from "./SellingSession"


export enum OrderPaymentStatus {
    AWAITING_PAYMENT = "awaitingPayment",
    PROCESSING = "processing",
    AUTHORIZED = "authorized",
    COMPLETED = "completed",
    FAILED = "failed",
    REFUNDED = "refunded",
    PARTIALLY_REFUNDED = "partiallyRefunded",
}

export enum OrderStatusTypeEnum {
    DRAFT = "draft",
    PENDING = "pending",
    COMPLETED = "completed",
    CANCELED = "canceled",
}

export enum OrderStatusEnum {
    draft = 'Brouillon',
    paid = 'Payée',
    not_paid = 'Non-payée',
    partiallyPaid = 'Partiellement payée',
    canceled = 'Annulée',
    invitation = 'Invitation',
    refunded = 'Remboursée',
    abandoned = 'Abandonnée'
}

export enum PaymentMethodTypeEnum {
    creditCard = 'creditCard',
    creditCardTerminal = 'creditCardTerminal',
    creditCardTerminalRevolut = 'creditCardTerminalRevolut',
    creditCardExternal = 'creditCardExternal',
    cash = "cash",
    check = "check",
    custom = "custom",
    free = 'free'
}

export enum PaymentMethodEnum {
    creditCard = 'Carte bancaire (Web)',
    creditCardTerminal = 'Tap to Pay',
    creditCardTerminalRevolut = 'TPE Revolut',
    creditCardExternal = 'Carte bancaire',
    cash = "Espèce",
    check = "Chèque",
    free = 'Aucun (gratuit)'
}

export enum OrderOriginTypeEnum {
    TICKET_OFFICE = 'ticketOffice',
    WEB = 'web',
    STOCK_IMPRESSION = 'stockImpression',
    INVITATION = 'invitation'
}

export enum OrderOriginEnum {
    ticketOffice = 'Guichet',
    web = 'Web',
    stockImpression = 'Impression de stock',
    invitation = 'Invitation'
}

type paymentMethod = {
    name: string
    amount: number
}

export enum PaymentReferer {
    WEB = "web",
    TICKET_OFFICE = "ticketoffice",
    BACK_OFFICE = "backoffice",
}

export interface OrderInvoiceData {
    civility?: string
    firstName?: string
    lastName?: string
    email?: string
    zone?: string
    additionalInfos?: string
    numTva?:string
    company?:string
    address?:string
}

export enum PaymentMethod {
    FREE = "free",
    CREDIT_CARD = "creditCard",
    CREDIT_CARD_TERMINAL = "creditCardTerminal",
    CREDIT_CARD_EXTERNAL = "creditCardExternal",
    CASH = "cash",
    CHECK = "check",
    INVITATION = "invitation",
    STOCK_IMPRESSION = "stockImpression",
    BANK_TRANSFER = "bankTransfer",
    CUSTOM = "custom",
}

export enum PaymentGateway {
    STRIPE = "stripe",
}

// Types d'ajustements supportés par l'API.
// Valeurs alignées sur AdjustmentType côté API
// (src/modules/common/entities/embedded/adjustement.embedded.ts).
export type OrderAdjustmentType = 'insurance' | 'editionFees' | 'promocode'

export interface OrderAdjustment {
    type?: OrderAdjustmentType | string
    amount: number
    label?: string
    tvaRate?: number
}

export interface Order {
    _id: string
    totalPrice?: {
        commission?: {
            flat: number
            percentage: number
            calculated: number
        }
        currency?: {
            isoCode: string
            value: any
        }
        promoCodeId?: string
        sellingPrice: number
        costPrice: number
        taxId: string
        // Calculé côté API : sellingPrice + sum(adjustments). Inclut
        // notamment l'assurance et les frais d'édition. Utiliser ce
        // champ comme total facturé / à encaisser.
        totalWithAdjustments?: number
        adjustments?: OrderAdjustment[]
    }
    sendingMethod?: string
    origin: OrderOriginTypeEnum
    isProduct?: boolean
    token: string
    amount?: number
    bookingTime?: number
    orderNumber?: string
    code?: number
    ticketOfficeSessionId?: SellingSession
    commissionIncreased?: boolean
    invoiceData?: OrderInvoiceData
    expire?: Date
    promoCode?: string
    status?: OrderStatusTypeEnum
    promoCodeValid?: boolean
    createdAt?: Date
    tickets?: ITicket[]
    payments?: OrderPayment[]
    hasInsurance?: boolean
    insurance?: {
        type?: 'neat' | null
        amount?: number
        contractId?: string | null
    } | null
    _app?: {
        paymentMethods?: paymentMethod[]
    }
}

export interface OrderPayment {
    _id: string
    method: PaymentMethod
    orderId: Order
    gateway: PaymentGateway | null
    customMethod: {
        label: string
        value: string
    }
    remoteId: string | null
    remoteStatus: string | null
    amount: number
    refundedAmount: number
    referer: PaymentReferer | null
    status: OrderPaymentStatus | null
}
